import globalAgent from 'src/agent';
import { API_URL } from 'src/constants/urls';

import type { AxiosPromise } from 'axios';

export interface ActivePackagePromotion {
    code: string;
    title: string;
    badge_text?: string;
    description?: string;
    applies_to?: string;
    multiplier: string | number;
    multiplier_label?: string;
    is_global?: boolean;
    category_id?: number | null;
}

export interface LeadCategory {
    id: number;
    name: string;
    description: string;
    icon: string;
    color: string;
    is_active: boolean;
    is_available_for_packages: boolean;
    is_delivery_enabled: boolean;
    availability_hint?: string;
    package_pricing_profile?: string | null;
    package_pricing_profile_label?: string | null;
    package_base_price_per_lead?: string | null;
    package_recommended_size?: number | null;
    active_package_promotion?: ActivePackagePromotion | null;
}

export interface LeadPackagePrice {
    id: number;
    category: number;
    package_size: number;
    price_per_lead: string;
    is_active: boolean;
}

export const getCategories = (): AxiosPromise<LeadCategory[]> => {
    return globalAgent.get(`/streams/categories/`);
};

export const getCategoryPrices = (categoryId: number): AxiosPromise<LeadPackagePrice[]> => {
    return globalAgent.get(`/streams/categories/${categoryId}/prices/`);
};

export interface CreateStreamRequest {
    category_id: number;
    name?: string;
    prompt?: string;
}

export interface Stream {
    id: number;
    user: number;
    category: LeadCategory;
    name: string | null;
    balance: number;
    prompt: string | null;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    package_size?: number;
    approved_deliveries?: number;
    active_access_offer_kind?: string | null;
    active_access_offer_name?: string | null;
    access_activated_at?: string | null;
    access_expires_at?: string | null;
    has_active_access?: boolean;
}

export const createStream = (data: CreateStreamRequest): AxiosPromise<Stream> => {
    return globalAgent.post(`/streams/streams/`, data);
};

export interface StreamsResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: Stream[];
}

export const getStreams = (): AxiosPromise<StreamsResponse | Stream[]> => {
    return globalAgent.get(`/streams/streams/`);
};

export interface PurchaseRequest {
    package_size: number;
    promo_code?: string;
    use_bonus_points?: boolean;
}

export interface PurchaseResponse {
    purchase_id: number;
    payment_id: string;
    confirmation_url: string;
    amount: {
        value: string;
        currency: string;
    };
    credited_package_size?: number;
    credited_access_duration_days?: number | null;
    credited_billing_period_months?: number | null;
    applied_promotion?: ActivePackagePromotion | null;
    applied_package_promotion?: ActivePackagePromotion | null;
}

export const purchasePackage = (streamId: number, data: PurchaseRequest): AxiosPromise<PurchaseResponse> => {
    return globalAgent.post(`/streams/streams/${streamId}/purchase/`, data);
};
